export default __webpack_public_path__ + "8bb1f274acafd8505469d97ea80afb43.png";